import * as R from 'ramda'

const noTranslationRegex = /<span class="notranslate">(.*?)<\/span>/
export const removeNoTranslationTag = R.replace(
  new RegExp(noTranslationRegex, 'g'),
  R.compose(R.prop('1'), R.match(noTranslationRegex)),
)

function removeKey(key) {
  return (obj) => {
    delete obj[key]
    return obj
  }
}

export const translationMapper = {
  toAPI: R.compose(removeKey('body'), (translation) => ({
    ...translation,
    fullBody: translation.body,
  })),
  fromAPI: R.compose(removeKey('fullBody'), (translation) => ({
    ...translation,
    body: translation.fullBody,
  })),
}
